export default "__VITE_ASSET__BwmBQP_I__"